export default __webpack_public_path__ + "img/ecCvZGce.dccc1151.svg";